/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProductManufacturer,
} from '../models/index';
import {
    ProductManufacturerFromJSON,
    ProductManufacturerToJSON,
} from '../models/index';

/**
 * 
 */
export class ManufacturerResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getManufacturers without sending the request
     */
    async getManufacturersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/products/manufacturer/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getManufacturersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductManufacturer>>> {
        const requestOptions = await this.getManufacturersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductManufacturerFromJSON));
    }

    /**
     */
    async getManufacturers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductManufacturer>> {
        const response = await this.getManufacturersRaw(initOverrides);
        return await response.value();
    }

}
